import Service1 from "../assets/img/real1.webp";
import Service2 from "../assets/img/real2.webp";
import Service3 from "../assets/img/real3.webp";
import Service4 from "../assets/img/real4.webp";
import Service7 from "../assets/img/real5.webp";
import Service8 from "../assets/img/real6.webp";
import Service9 from "../assets/img/real7.webp";
import Service10 from "../assets/img/real8.webp";
import Service11 from "../assets/img/real9.webp";
import Service12 from "../assets/img/real10.webp";
import Service13 from "../assets/img/real11.webp";
import Service14 from "../assets/img/real12.webp";
import Service15 from "../assets/img/real13.webp";
import Service16 from "../assets/img/real14.webp";
import Service17 from "../assets/img/real15.webp";
import Service18 from "../assets/img/real16.webp";
import Service19 from "../assets/img/real17.webp";
import Service20 from "../assets/img/real18.webp";
import Service21 from "../assets/img/real19.webp";
import Service22 from "../assets/img/real20.webp";
import Service23 from "../assets/img/real21.webp";
import Service24 from "../assets/img/real22.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const cards = [
  {
    img: Service1,
  },
  {
    img: Service2,
  },
  {
    img: Service4,
  },
  {
    img: Service3,
  },
  {
    img: Service8,
  },
  {
    img: Service7,
  },
  {
    img: Service9,
  },
  {
    img: Service10,
  },
  {
    img: Service11,
  },
  {
    img: Service12,
  },
  {
    img: Service13,
  },
  {
    img: Service14,
  },
  {
    img: Service15,
  },
  {
    img: Service16,
  },
  {
    img: Service17,
  },
  {
    img: Service18,
  },
  {
    img: Service19,
  },
  {
    img: Service20,
  },
  {
    img: Service21,
  },
  {
    img: Service22,
  },
];

export default function Carousel2() {
  return (
    <div>
      {/* Carrousel2 - 3 cards visibles, défilement auto et smooth */}
      <div className="carousel-container">
        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={3}
          centeredSlides={true}
          loop={true}
          navigation
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          className="carousel-swiper"
          breakpoints={{
            0: { slidesPerView: 1, centeredSlides: false },
            900: { slidesPerView: 2, centeredSlides: false },
            1200: { slidesPerView: 2, centeredSlides: false },
            1400: { slidesPerView: 3, centeredSlides: true },
          }}
        >
          {cards.map((card, idx) => (
            <SwiperSlide key={idx}>
              <div
                className="carousel-card2"
                style={{
                  backgroundImage: `url(${card.img})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "#fff",
                  height: "450px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div className="carousel-card-content">
                  <h3>{card.title}</h3>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
